import '../favicon.ico';
import './sass/app.style.scss';
import '../vendor-styles';
